const TESTIMONIALS = [
  {
    text: "Servicio impecable. El conductor nos esperaba con un cartel y el coche estaba inmaculado. Muy profesionales.",
    name: "María García",
    location: "Madrid"
  },
  {
    text: "Best transfer service we've used in Spain. Professional, punctual, and the Mercedes was fantastic.",
    name: "John Smith",
    location: "Londres"
  },
  {
    text: "Uso sus servicios para todos mis viajes de negocios a Málaga. Siempre puntuales y con vehículos de primera.",
    name: "Carlos Rodríguez",
    location: "Barcelona"
  }
];

// Testimonials Section - Mobile Optimized
const TestimonialsSection = () => {
  return (
    <section className="py-16 sm:py-24 px-4" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <p className="section-subtitle">Testimonios</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: "'Cinzel', serif" }}>
            Lo Que Dicen Nuestros <span className="gradient-text">Clientes</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8">
          {TESTIMONIALS.map((testimonial, idx) => (
            <article
              key={idx}
              className="glass rounded-xl p-5 sm:p-8"
              data-testid={`testimonial-${idx}`}
            >
              <div className="flex gap-1 mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fas fa-star text-[#c9a962] text-sm"></i>
                ))}
              </div>
              <p className="text-sm sm:text-base text-gray-300 italic mb-4 sm:mb-6 leading-relaxed">"{testimonial.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#c9a962]/20 flex items-center justify-center">
                  <i className="fas fa-user text-[#c9a962] text-xs sm:text-sm"></i>
                </div>
                <div>
                  <p className="font-semibold text-white text-sm sm:text-base">{testimonial.name}</p>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
